import type { ApiResponse } from 'apisauce';
import type { Api } from './api';
import type { localeTypes } from '../../../@types/i18next';

export interface TOrganization {
  id: string;
  name: string;
  code: string;
  description: string;
  email: string;
  maxCancellationTime: number;
  overdueCancellationPenalty: number;
  activeDays: string;
  activeMonths: string;
  tz: string;
  phone: string;
  address: string;
  location: string;
  postalCode: string;
  currency: string;
  icon: string;
  createdBy: string;
  updatedBy: string;
  createdAt: number;
  updatedAt: number;
  active: boolean;
}

interface TLanguage {
  createdBy: string;
  updatedBy: string;
  createdAt: number;
  updatedAt: number;
  active: boolean;
  id: string;
  name: string;
  englishName: string;
  code: localeTypes;
}

export interface TFaq {
  id: string;
  language: TLanguage;
  question: string;
  answer: string;
  order: number;
}

export interface TTos {
  id: string;
  language: TLanguage;
  organization: TOrganization;
  text: string;
  order: number;
}

export interface TOrganizationFAQ extends TOrganization {
  faq: TFaq[];
  tos: TTos[];
}

export interface TGetOganization {
  total: number;
  limit: number;
  offset: number;
  page: number;
  hasNextPage: boolean;
  results: TOrganizationFAQ[];
}

export class OrganizationApi {
  readonly api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async getOrganization(
    organizationName: string
  ): Promise<TOrganizationFAQ | undefined> {
    await this.api.getRequestConfig();
    const response: ApiResponse<TOrganizationFAQ> = await this.api.apisauce.get(
      `organization/${organizationName}`
    );
    if (!response.ok) {
      throw response.originalError;
    }
    return response.data;
  }

  async getOrganizationCustomer(): Promise<TOrganizationFAQ[] | undefined> {
    await this.api.getRequestConfig();
    const response: ApiResponse<TGetOganization> = await this.api.apisauce.get(
      'organization/customer'
    );
    if (!response.ok) {
      throw response.originalError;
    }
    return response.data?.results;
  }
}
